import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import i18n from './i18n'; // Initialize i18n
import { updateSEOMetadata } from './utils/seoMetadata';
import App from './App.jsx'
// Service Worker is now handled by the UpdatePrompt component

// Update SEO metadata when language changes
i18n.on('languageChanged', (lng) => {
  updateSEOMetadata(lng);
});

// Set initial SEO metadata
updateSEOMetadata(i18n.language);

import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
